<template>
  <div
    id="vue-gf-beneficiary-search"
    class="container px-0 mb-4"    
  >
    <GfCharity
      :event-campaign-id="eventCampaignId > 0 ? eventCampaignId.toString() : ''"
      :beneficiary-id="beneficiaryId"
      :allow-preselection-change="allowPreselectionChange"
      :ignore-event-tiering="ignoreEventTiering"
      :region="region ? region.toUpperCase() : region"      
      :after-select-call-back="afterSelectCallBack"
      :after-reset-call-back="afterResetCallBack"
      :external="external"
      :mode="mode"
      :config="getConfig"
      :tag-ids-as-csv="tagIdsAsCsv"
      :show-more-results-info-text="showMoreResultsInfoText"
      :paging-settings="pagingSettings"
      @reset="reset"
      @selected="selected"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import useFontawesome from './composables/useFontawesome'
import usePlugins from './composables/usePlugins'
import VueScrollTo from 'vue-scrollto'
import GfCharity from './components/GfCharity.vue'
import store from './store'

export default {
  name: 'GfBeneficiarySearch',
  components: {
    GfCharity,
  },
  props: {
		eventCampaignId: {
			type: Number,
			default: 0,
		},
    beneficiaryId: {
			type: Number,
			default: 0,
		},		
		region: {
			type: String,
			default: '',
		},
		apiDomain: {
			type: String,
			default: '',
		},
		afterSelectCallBack: {
			type: String,
			default: '',
		},
		afterResetCallBack: {
			type: String,
			default: '',
		},
		external: {
			type: Object,
			default: () => {},
    },
		mode: {
			type: Object,
			default: () => ({
        name: 'beneficiaryCard',    
        settings: {},
			}),
    },
    config: {
      type: Object,
      default: () => {},
    },
    tagIdsAsCsv: {
      type: String,
      default: '',
    },
    allowPreselectionChange: {
      type: Boolean,
      default: false,
    },
    ignoreEventTiering: {
      type: Boolean,
      default: false,
    },
    showMoreResultsInfoText: {
      type: Boolean,
      default: true,
    },
    pagingSettings: {
      type: String,
      default: 'infinite',
    },
    disableAutoFocus: {
      type: Boolean,
      default: false,
    },
	},
  setup(props, { emit }) {
    const defaultConfig = ref({
      otherCharitiesTitle: 'Other',
      tieredRefineSearchText: 'More charities may be available, try entering a search text',
      tooManyResultsText: 'Looks like there\'s too many results, try refining your search',
      noResultsText: 'Can\'t see your charity here? Email support@gofundraise.com to nominate your charity.',
    })
    
    const getConfig = computed(() => {
      return Object.assign(defaultConfig.value, props.config);
    })

    const initialize = () => {
      usePlugins.install({
        apiDomain: props.apiDomain,
        region: props.region ? props.region.toUpperCase() : props.region,
      })
      useFontawesome.install()
      store.commit('setProps', props)
    }

    const scrollToComponent = () => {
      if (props.disableAutoFocus)
        return

      emit('scrollToComponent', true)
      setTimeout(() => {
        VueScrollTo.scrollTo('#vue-gf-beneficiary-search', '100', {
          easing: 'ease-in',
          offset: -60,
          force: true,
        })
      }, 1000)
    }

    const reset = paramValues => {
			emit('reset', paramValues)
		}

    const selected = paramValues => {
			emit('selected', paramValues)
		}

    initialize()

    onMounted(() => {
      scrollToComponent()
    })

    return {
      defaultConfig,
      getConfig,
      reset,
      selected,
    }
  }
}
</script>

<style lang="scss">
@import './assets/custom.scss';

#vue-gf-beneficiary-search {
  @import 'bootstrap/scss/bootstrap';
}


#vue-gf-beneficiary-search {
  font-family: 'bariol_regularregular'
}

</style>
